import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { updateExtension, IUpdateExtensionRequest, IExtension } from 'src/api/extensions';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

interface IUpdateExtensionParams {
  brandId: string;
  extensionId: string;
  payload: IUpdateExtensionRequest;
}

export const useUpdateExtension = (onSuccess?: (data: IExtension) => void) => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ brandId, extensionId, payload }: IUpdateExtensionParams) =>
      updateExtension(brandId, extensionId, payload),
    onSuccess: (data: IExtension, variables) => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.EXTENSIONS, variables.brandId] });
      showSnackbar({
        status: SnackbarStatus.SUCCESS,
        message: 'Authentication updated successfully.',
      });
      onSuccess?.(data);
    },
    onError: (error: Error) => {
      showSnackbar({
        message: error.message || 'Unable to update authentication',
        status: SnackbarStatus.ERROR,
      });
      captureException(error);
    },
  });
};
